import { getCookie } from '@tencent/ark-utils/lib/cookie';
var P_LS_KEY = 'p_lskey';
var P_S_KEY = 'p_skey';
var VFWEBQQ_KEY = 'vfwebqq';
export function camel2UnderScore(name) {
    if (name.length === 0) {
        return name;
    }
    var result = name[0].toLowerCase() + name.substr(1);
    return result.replace(/([A-Z])/g, function ($1) { return "_".concat($1.toLowerCase()); });
}
export function underScore2Camel(name) {
    var array = name.split('_');
    var result = '';
    for (var i = 0; i < array.length; i++) {
        var temp = array[i];
        if (temp.length > 0) {
            if (i === 0) {
                result += temp;
            }
            else {
                temp = "".concat(temp[0].toUpperCase()).concat(temp.substring(1));
                result += temp;
            }
        }
    }
    return result;
}
/**
 * 判断cgi返回的数据是有值的，并且retcode和cgicode都是正常的
 * @param data
 */
export function isCgiDataAndRetCodePerfected(data) {
    if (!data) {
        return false;
    }
    if (data.retcode === 0 /* RETCODE.SUCCESS */ && data.cgicode === 0 /* BASE_CGICODE.SUCCESS */) {
        return true;
    }
    return false;
}
/**
 * 判断是否存在，存在返回，不存在返回空字符串
 * @param param
 */
export function exitOrEmptyString(param) {
    return param || '';
}
/**
 * 判断是否存在，存在返回，不存在返回空字符串
 * @param param
 */
export function exitOrZero(param) {
    return param || 0;
}
/**
 * 生成伪随机UUID
 */
export function getUUID() {
    var date = Date.now();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var random = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (c === 'x' ? random : ((random & 0x3) | 0x8)).toString(16);
    });
    return uuid;
}
export function getPLSkey() {
    return getCookie(P_LS_KEY);
}
export function getSKey() {
    return getCookie(P_S_KEY);
}
export function getVfWebQQ() {
    return getCookie(VFWEBQQ_KEY) || '';
}
/**
 * Object 类型转 FormData类型,
 *
 * @param params
 * @returns FormData数据类型
 */
export function getFormDataWithParams(params) {
    var data = new FormData();
    var keys = Object.keys(params);
    keys.forEach(function (key) {
        data.append(key, params[key]);
    });
    return data;
}
/**
 * Object 类型转 FormData类型, 但是会过滤掉 undefined 的值
 */
export function getFormDataWithParamsFilterUndefined(params) {
    var data = new FormData();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var keys = Object.keys(params);
    keys.forEach(function (key) {
        if (params[key] === undefined)
            return;
        data.append(key, params[key]);
    });
    return data;
}
/**
 * Object 类型转 URLSearchParams 类型, 但是会过滤掉 undefined 的值
 * 一般用于作为 application/x-www-form-urlencoded 的数据来发送
 */
export function toURLSearchParams(params) {
    var data = new URLSearchParams();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    Object.keys(params).forEach(function (key) {
        if (params[key] === undefined)
            return;
        data.append(key, params[key]);
    });
    return data;
}
/**
 * 根据 domainId 与 localPadId 合并成 globalPadId，兼容 B 端文档 domainId 的特殊场景
 * @param domainId C 端为 '300000000', B 端为 '0' 或 ''
 * @param localPadId 文档 padId
 * @returns 合并后的 globalPadId
 */
export function getGlobalPadId(domainId, localPadId) {
    var weComDomainIdCases = ['0', ''];
    if (weComDomainIdCases.includes(domainId)) {
        return localPadId;
    }
    return "".concat(domainId, "$").concat(localPadId);
}
export var getXsrfToken = function () { return getCookie('TOK'); };
export function safeParseObject(obj, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = undefined; }
    try {
        return JSON.parse(obj);
    }
    catch (e) {
        return fallbackValue;
    }
}
